export default "__VITE_ASSET__i_yBH7uydOoM63K_K2S1vA__"